import { call, put, select } from 'redux-saga/effects';
import { getFormValues } from 'redux-form/immutable';
import moment from 'moment';
import { push } from 'redux-little-router';
import { QUALIFIED_APPLICATION_FORM } from '../constants';
import { selectPIQO } from 'modules/Profile/redux/participationInQesOrganization/selectors';
import { selectPersonalDataContent } from 'modules/Profile/redux/personalData/selectors';
import { submitQSADataFailure, submitQSASuccess } from '../redux/actions';
import { submitQSA } from '../services/api';

export function* submitQSASaga({ payload: { step } }) {
  const formData = yield select(getFormValues(QUALIFIED_APPLICATION_FORM));
  const organizations = yield select(selectPIQO);
  const personalData = yield select(selectPersonalDataContent);
  const organization =
    organizations.get('data') &&
    organizations.get('data').find(({ orgInn }) => orgInn === formData.get('legalEntity'));
  if (formData.get('inn')) {
    const { isOk, data, error } = yield call(submitQSA, {
      organization,
      status: formData.get('selectStatus'),
      signer: {},
      taxPayer: {
        residenceAddress: personalData.residenceAddress,
        inn: formData.get('inn'),
        birthDate:
          formData.get('dateOfBirth') && moment(formData.get('dateOfBirth')).isValid()
            ? formData.get('dateOfBirth').format('YYYY-MM-DD')
            : null,
        gender: formData.get('gender'),
        personName: {
          firstName: formData.get('firstName'),
          middleName: formData.get('middleName'),
          lastName: formData.get('lastName'),
        },
        personId: {
          idType: formData.get('documentType'),
          idNumber: formData.get('documentNumber'),
          idDate:
            formData.get('documentDate') && moment(formData.get('documentDate')).isValid()
              ? formData.get('documentDate').format('YYYY-MM-DD')
              : null,
          idIssuer: formData.get('issuedBy'),
          idIssuerCode: formData.get('departmentCode'),
        },
      },
      title: formData.get('title'),
    });
    if (isOk) {
      yield put(submitQSASuccess(data));
      yield put(push({ query: { step } }, { persistQuery: true }));
    } else {
      yield put(submitQSADataFailure(error));
    }
  }
}
